export const parseInstagramHTML = (htmlString, myUsername, mediaFiles = {}, isBottomUp = true) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  
  const messages = [];
  
  console.log('Starting HTML parsing with specific Instagram class selectors...');
  console.log('Document body children count:', doc.body.children.length);
  
  // Try the specific Instagram message container class first
  // Class: pam _3-95 _2ph- _a6-g uiBoxWhite noborder
  let messageNodes = Array.from(doc.querySelectorAll('.pam._3-95._2ph-._a6-g.uiBoxWhite.noborder'));
  
  if (messageNodes.length > 0) {
    console.log(`Found ${messageNodes.length} messages using specific Instagram container class`);
  } else {
    // Try alternative selectors
    const selectors = [
      '.pam._3-95._2pi0._2lej.uiBoxWhite.noborder',
      '.pam.uiBoxWhite.noborder',
      '.pam._3-95',
      '._3b0d',
      '.pam',
      'div[role="row"]',
      'div[class*="_2pio"]',
      'div[class*="_3-95"]',
      'div[class*="message"]',
      'div[class*="chat"]'
    ];
    
    for (const selector of selectors) {
      messageNodes = Array.from(doc.querySelectorAll(selector));
      if (messageNodes.length > 0) {
        console.log(`Found ${messageNodes.length} messages using selector: ${selector}`);
        break;
      }
    }
  }
  
  // Fallback: Look for any divs that have text content and nested structure
  if (messageNodes.length === 0) {
    console.log('Trying fallback: looking for divs with 2-10 child divs');
    const allDivs = Array.from(doc.body.querySelectorAll('div'));
    messageNodes = allDivs.filter(div => {
      const childDivs = div.querySelectorAll(':scope > div');
      const hasText = div.textContent && div.textContent.trim().length > 0;
      return hasText && childDivs.length >= 2 && childDivs.length <= 10;
    });
    console.log(`Fallback: Found ${messageNodes.length} potential message containers`);
  }

  // Log sample of what we found
  if (messageNodes.length > 0) {
    console.log('Sample node HTML:', messageNodes[0].outerHTML.substring(0, 500));
    console.log('Sample node text:', (messageNodes[0].innerText || messageNodes[0].textContent).substring(0, 200));
  }

  // Process messages from bottom to top if requested
  if (isBottomUp) {
    messageNodes.reverse();
    console.log('Processing messages from bottom to top');
  }

  messageNodes.forEach((node, index) => {
    try {
      // Try to extract using specific Instagram classes first
      // Sender name: class="_3-95 _2pim _a6-h _a6-i"
      let senderElement = node.querySelector('._3-95._2pim._a6-h._a6-i');
      // Message content: class="_3-95 _a6-p"
      let contentElement = node.querySelector('._3-95._a6-p');
      // Time: class="_3-94 _a6-o"
      let timeElement = node.querySelector('._3-94._a6-o');
      
      let sender = '';
      let content = '';
      let timestampStr = '';
      
      if (senderElement && contentElement) {
        // Found specific Instagram format
        sender = (senderElement.innerText || senderElement.textContent || '').trim();
        content = (contentElement.innerText || contentElement.textContent || '').trim();
        if (timeElement) {
          timestampStr = (timeElement.innerText || timeElement.textContent || '').trim();
        }
        
        console.log(`Message ${index}: Using specific classes - sender="${sender}", content="${content.substring(0, 30)}...", time="${timestampStr}"`);
      } else {
        // Fallback to generic parsing
        const textContent = node.innerText || node.textContent;
        if (!textContent || textContent.trim().length === 0) return;

        // Get all child divs for more structured parsing
        const childDivs = Array.from(node.querySelectorAll(':scope > div'));
        
        // Helper function to check if a string looks like a timestamp
        const looksLikeTimestamp = (str) => {
          if (!str) return false;
          const timestampPatterns = [
            /\d{1,2}:\d{2}/,  // Time like 10:30
            /\d{4}-\d{2}-\d{2}/, // Date like 2025-12-08
            /\d{1,2}\/\d{1,2}\/\d{2,4}/, // Date like 12/8/2025
            /\b(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)/i, // Month names
            /\b(?:AM|PM)\b/i, // AM/PM
            /\b(?:UTC|GMT|EST|PST|IST)\b/i, // Timezone abbreviations
          ];
          return timestampPatterns.some(pattern => pattern.test(str));
        };

        if (childDivs.length >= 2) {
          // Structured approach: parse child divs
          const texts = childDivs.map(div => (div.innerText || div.textContent || '').trim()).filter(t => t);
          
          if (texts.length >= 3) {
            // 3+ texts: likely [sender, content, timestamp] or [sender, content1, content2, ..., timestamp]
            sender = texts[0];
            
            // Find which text is the timestamp by checking if it looks like a date/time
            let timestampIndex = -1;
            for (let i = texts.length - 1; i >= 1; i--) {
              if (looksLikeTimestamp(texts[i])) {
                timestampIndex = i;
                break;
              }
            }
            
            if (timestampIndex > 0) {
              timestampStr = texts[timestampIndex];
              content = texts.slice(1, timestampIndex).join('\n');
            } else {
              // No timestamp found, treat everything after sender as content
              content = texts.slice(1).join('\n');
              timestampStr = '';
            }
          } else if (texts.length === 2) {
            // 2 texts: could be [sender, content] or [sender, timestamp] or [content, timestamp]
            if (looksLikeTimestamp(texts[1]) && !looksLikeTimestamp(texts[0])) {
              // Likely [sender, timestamp] - but where's the content?
              sender = texts[0];
              timestampStr = texts[1];
              // Try to get content from the node's text content
              const allText = textContent.split('\n').map(l => l.trim()).filter(l => l);
              const contentParts = allText.filter(line => line !== sender && line !== timestampStr);
              content = contentParts.join('\n');
            } else {
              // Likely [sender, content]
              sender = texts[0];
              content = texts[1];
              timestampStr = '';
            }
          }
        } else {
          // Fallback to line-based parsing
          const lines = textContent.split('\n').map(l => l.trim()).filter(l => l);
          if (lines.length < 2) return;
          
          // Find timestamp in lines
          let timestampIndex = -1;
          for (let i = lines.length - 1; i >= 0; i--) {
            if (looksLikeTimestamp(lines[i])) {
              timestampIndex = i;
              break;
            }
          }
          
          if (timestampIndex > 0) {
            sender = lines[0];
            timestampStr = lines[timestampIndex];
            content = lines.slice(1, timestampIndex).join('\n');
            if (content.length === 0 && timestampIndex === lines.length - 1 && lines.length > 2) {
              content = lines.slice(1, -1).join('\n');
            }
          } else {
            // No clear timestamp found
            sender = lines[0];
            content = lines.slice(1).join('\n');
            timestampStr = '';
          }
        }
      }
      
      // Skip if we don't have basic required fields
      if (!sender || !content) {
        if (index < 3) {
          console.log(`Skipping node ${index}: sender="${sender}", content="${content}"`);
        }
        return;
      }

      // Try to parse the timestamp
      let date = new Date(timestampStr);
      
      // If parsing fails, try various date formats
      if (isNaN(date.getTime())) {
        // Try to find a date-like pattern in the text
        const datePatterns = [
          /(\w{3,9}\s+\d{1,2},?\s+\d{4}[,\s]+\d{1,2}:\d{2}\s*(?:AM|PM)?)/i,
          /(\d{1,2}\/\d{1,2}\/\d{2,4}[,\s]+\d{1,2}:\d{2}\s*(?:AM|PM)?)/i,
          /(\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2})/,
        ];
        
        for (const pattern of datePatterns) {
          const match = timestampStr.match(pattern);
          if (match) {
            date = new Date(match[1]);
            if (!isNaN(date.getTime())) break;
          }
        }
        
        // If still invalid, use null to indicate no valid timestamp
        if (isNaN(date.getTime())) {
          date = null;
        }
      }

      // Extract media files from the message node
      const mediaItems = [];
      
      // Helper function to strip Instagram path prefix
      const stripInstagramPrefix = (path) => {
        if (!path) return path;
        const prefixes = [
          'your_instagram_activity/messages/inbox/',
          'your_instagram_activity\\messages\\inbox\\',
          '../your_instagram_activity/messages/inbox/',
          '../your_instagram_activity\\messages\\inbox\\'
        ];
        
        let cleanPath = path;
        for (const prefix of prefixes) {
          if (path.includes(prefix)) {
            cleanPath = path.substring(path.indexOf(prefix) + prefix.length);
            break;
          }
        }
        return cleanPath;
      };
      
      // Look for images
      const images = node.querySelectorAll('img');
      images.forEach(img => {
        const src = img.getAttribute('src') || img.getAttribute('data-src');
        if (src) {
          // Try to find matching media file
          let mediaUrl = null;
          const cleanSrc = stripInstagramPrefix(src);
          const filename = src.split('/').pop().split('\\').pop().split('?')[0];
          
          // Try various path combinations
          if (mediaFiles[src]) {
            mediaUrl = mediaFiles[src];
          } else if (mediaFiles[cleanSrc]) {
            mediaUrl = mediaFiles[cleanSrc];
          } else if (mediaFiles[filename]) {
            mediaUrl = mediaFiles[filename];
          } else if (mediaFiles[`photos/${filename}`]) {
            mediaUrl = mediaFiles[`photos/${filename}`];
          } else if (mediaFiles[`videos/${filename}`]) {
            mediaUrl = mediaFiles[`videos/${filename}`];
          }
          
          if (mediaUrl) {
            mediaItems.push({
              type: 'image',
              url: mediaUrl,
              alt: img.getAttribute('alt') || 'Image'
            });
          }
        }
      });
      
      // Look for videos
      const videos = node.querySelectorAll('video, video source');
      videos.forEach(video => {
        const src = video.getAttribute('src') || video.getAttribute('data-src');
        if (src) {
          const cleanSrc = stripInstagramPrefix(src);
          const filename = src.split('/').pop().split('\\').pop().split('?')[0];
          let mediaUrl = null;
          
          if (mediaFiles[src]) {
            mediaUrl = mediaFiles[src];
          } else if (mediaFiles[cleanSrc]) {
            mediaUrl = mediaFiles[cleanSrc];
          } else if (mediaFiles[filename]) {
            mediaUrl = mediaFiles[filename];
          } else if (mediaFiles[`videos/${filename}`]) {
            mediaUrl = mediaFiles[`videos/${filename}`];
          }
          
          if (mediaUrl) {
            mediaItems.push({
              type: 'video',
              url: mediaUrl
            });
          }
        }
      });
      
      // Look for video links with class "_a6_o _3-96"
      const videoLinks = node.querySelectorAll('a._a6_o._3-96');
      videoLinks.forEach(link => {
        const href = link.getAttribute('href');
        if (href) {
          const cleanHref = stripInstagramPrefix(href);
          const filename = href.split('/').pop().split('\\').pop().split('?')[0];
          let mediaUrl = null;
          
          if (mediaFiles[href]) {
            mediaUrl = mediaFiles[href];
          } else if (mediaFiles[cleanHref]) {
            mediaUrl = mediaFiles[cleanHref];
          } else if (mediaFiles[filename]) {
            mediaUrl = mediaFiles[filename];
          } else if (mediaFiles[`videos/${filename}`]) {
            mediaUrl = mediaFiles[`videos/${filename}`];
          }
          
          if (mediaUrl) {
            mediaItems.push({
              type: 'video',
              url: mediaUrl
            });
          }
        }
      });
      
      // Look for audio
      const audios = node.querySelectorAll('audio, audio source');
      audios.forEach(audio => {
        const src = audio.getAttribute('src') || audio.getAttribute('data-src');
        if (src) {
          const cleanSrc = stripInstagramPrefix(src);
          const filename = src.split('/').pop().split('\\').pop().split('?')[0];
          let mediaUrl = null;
          
          if (mediaFiles[src]) {
            mediaUrl = mediaFiles[src];
          } else if (mediaFiles[cleanSrc]) {
            mediaUrl = mediaFiles[cleanSrc];
          } else if (mediaFiles[filename]) {
            mediaUrl = mediaFiles[filename];
          } else if (mediaFiles[`audio/${filename}`]) {
            mediaUrl = mediaFiles[`audio/${filename}`];
          }
          
          if (mediaUrl) {
            mediaItems.push({
              type: 'audio',
              url: mediaUrl
            });
          }
        }
      });

      const message = {
        sender: sender,
        content: content,
        timestamp: date || new Date(0), // Use epoch time for sorting if no valid date
        originalTime: timestampStr,
        isMine: sender.toLowerCase().includes(myUsername.toLowerCase()),
        media: mediaItems.length > 0 ? mediaItems : null
      };
      
      if (messages.length < 3) {
        console.log(`Parsed message ${messages.length}:`, message);
      }
      
      messages.push(message);
    } catch (error) {
      console.error('Error parsing message node:', error);
    }
  });

  // Sort by date to ensure correct order (oldest first)
  messages.sort((a, b) => a.timestamp - b.timestamp);
  
  console.log(`Parsed ${messages.length} messages total`);
  return messages;
};